import React from "react";
import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const authToken = localStorage.getItem("auth_token");

  if (authToken) {
    return children;
  }

  return <Navigate to="/" replace />;
}
